import { API_ENDPOINTS } from "../../constants/common";
import { webApi } from "../../utils/api";

export const getCustomerSettings = (account, businessId) =>
  webApi
    .get({
      path: API_ENDPOINTS.ACCOUNT_SETTINGS,
      query: {
        account,
        businessId,
      },
    })
    .then((res) => res.data);

export const updateCustomerSettings = (body) =>
  webApi
    .put({
      path: API_ENDPOINTS.ACCOUNT_SETTINGS,
      body,
    })
    .then((res) => res.data);
